import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import batteryEngine from '../../../../../Widgets/DataPainterWidget/BatteryWidget/BatteryEngine';
import { CMD_BATTERY_REGISTRY_KEY, META_TYPE, META_VER } from './batteryCommandRegisteryType';

/**
 * Registers the /battery command with the CommandEngine.
 * Call once at module load from CommandEngine.bootup.
 *
 * /battery <rk> — opens/refocuses that battery's card (multi-instance, target=rk),
 * same shape as /pnl3 <symbol>. `params` is a getter (not a static array) so the rk
 * dropdown reflects whatever's in BatteryCache at the moment the user types — CmdBarEdit
 * re-reads commandEngine.getCommand(cmd).params on every keystroke, so this needs no
 * changes to CommandEngine/CmdBarEdit itself.
 */
export function registerBatteryCommand() {
    commandEngine.register('/battery', {
        hint: '<rk> — open battery card, e.g. /battery HOA1NAN9N363820',
        get params() {
            return [
                {
                    name: 'rk',
                    options: batteryEngine.getAll().map((b) => ({ label: `${b.name} (${b.rk})`, value: b.rk })),
                },
            ];
        },
        handler: (params) => {
            const [rk] = params;
            if (!rk) return;

            cardPainterManager.openCard(CMD_BATTERY_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: rk });
        },
    });
}
